// @ts-nocheck
/* Starter Sync - MyListsDetailsHeader */

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getWishListLinesDataView } from "@insite/client-framework/Store/Data/WishListLines/WishListLinesSelectors";
import {
    getWishListState,
    getWishListTotal,
    getWishListTotalWithVat,
} from "@insite/client-framework/Store/Data/WishLists/WishListsSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LocalizedCurrency from "@insite/content-library/Components/LocalizedCurrency";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { orderSummaryProps } from "@store/Themes/common/props/order";
import React from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => {
    const wishListLinesDataView = getWishListLinesDataView(state, state.pages.myListDetails.loadWishListLinesParameter);

    return {
        wishList: getWishListState(state, state.pages.myListDetails.wishListId).value,
        wishListTotal: getWishListTotal(wishListLinesDataView, state.pages.myListDetails.productInfosByWishListLineId),
        enableVat: getSettingsCollection(state).productSettings.enableVat,
        vatPriceDisplay: getSettingsCollection(state).productSettings.vatPriceDisplay,
        wishListTotalWithVat: getWishListTotalWithVat(
            wishListLinesDataView,
            state.pages.myListDetails.productInfosByWishListLineId,
        ),
        showPricing: state.context.showPricing,
    };
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface MyListsDetailsTotalStyles {
    wrapper?: InjectableCss;
    titleWrapper?: InjectableCss;
    title?: TypographyProps;
    itemWrapper?: InjectableCss;
    totalLabel?: TypographyProps;
    totalValue?: TypographyProps;
    realTimeText?: TypographyPresentationProps;
}

export const myListsDetailsTotalStyles: MyListsDetailsTotalStyles = {
    wrapper: orderSummaryProps.wrapper,
    titleWrapper: orderSummaryProps.titleWrapper,
    title: orderSummaryProps.title,
    itemWrapper: orderSummaryProps.itemWrapper,
    totalLabel: orderSummaryProps.totalLabel,
    totalValue: orderSummaryProps.totalValue,
    realTimeText: orderSummaryProps.realTimeText,
};

const styles = myListsDetailsTotalStyles;

const MyListsDetailsTotal = ({
    wishList,
    wishListTotal,
    wishListTotalWithVat,
    enableVat,
    vatPriceDisplay,
    showPricing,
}: Props) => {
    if (!wishList || !showPricing) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper} data-test-selector="listTotal">
            <StyledWrapper {...styles.titleWrapper}>
                <Typography {...styles.title}>{translate("Order Summary")}</Typography>
            </StyledWrapper>
            <StyledWrapper {...styles.itemWrapper}>
                <Typography {...styles.totalLabel}>
                    {translate("Total")}
                    {enableVat &&
                        ` (${vatPriceDisplay === "DisplayWithoutVat" ? translate("Ex. VAT") : translate("Inc. VAT")})`}
                </Typography>
                <Typography {...styles.totalValue}>
                    {wishListTotal !== undefined ? (
                        <LocalizedCurrency
                            amount={
                                enableVat && vatPriceDisplay !== "DisplayWithoutVat" && wishListTotalWithVat
                                    ? wishListTotalWithVat
                                    : wishListTotal
                            }
                        />
                    ) : (
                        <Typography {...styles.realTimeText} />
                    )}
                </Typography>
            </StyledWrapper>
            {enableVat && vatPriceDisplay === "DisplayWithAndWithoutVat" ? (
                <StyledWrapper {...styles.itemWrapper}>
                    <Typography {...styles.totalLabel}>
                        {translate("Total")} ({translate("Ex. VAT")})
                    </Typography>
                    <Typography {...styles.totalValue}>
                        {wishListTotal !== undefined ? (
                            <LocalizedCurrency amount={wishListTotal} />
                        ) : (
                            <Typography {...styles.realTimeText} />
                        )}
                    </Typography>
                </StyledWrapper>
            ) : null}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(MyListsDetailsTotal),
    definition: {
        group: "My Lists Details",
        allowedContexts: ["MyListsDetailsPage"],
        displayName: "Total",
    },
};

export default widgetModule;
